import { defineComponent as p, openBlock as a, createElementBlock as o, mergeProps as u, unref as l, renderSlot as H, createElementVNode as e, createCommentVNode as g } from "vue";
import { useScalarIcon as M } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, m = { key: 1 }, h = { key: 2 }, f = { key: 3 }, A = { key: 4 }, V = { key: 5 }, w = {
  name: "ScalarIconArrowLineDownLeft"
}, v = /* @__PURE__ */ p({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = M(s);
    return (i, t) => (a(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(d)), [
      H(i.$slots, "default"),
      l(n) === "bold" ? (a(), o("g", Z, t[0] || (t[0] = [
        e("path", { d: "M236,48a12,12,0,0,1-12,12H48a12,12,0,0,1,0-24H224A12,12,0,0,1,236,48ZM175.51,87.51,84,179V112a12,12,0,0,0-24,0v96a12,12,0,0,0,12,12h96a12,12,0,0,0,0-24H101l91.52-91.51a12,12,0,0,0-17-17Z" }, null, -1)
      ]))) : l(n) === "duotone" ? (a(), o("g", m, t[1] || (t[1] = [
        e("path", {
          d: "M168,208H72V112Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M232,48a8,8,0,0,1-8,8H48a8,8,0,0,1,0-16H224A8,8,0,0,1,232,48ZM189.66,90.34a8,8,0,0,1,0,11.32L131.31,160l42.35,42.34A8,8,0,0,1,168,216H72a8,8,0,0,1-8-8V112a8,8,0,0,1,13.66-5.66L120,148.69l58.34-58.35A8,8,0,0,1,189.66,90.34ZM148.69,200l-34.34-34.34h0L80,131.31V200Z" }, null, -1)
      ]))) : l(n) === "fill" ? (a(), o("g", h, t[2] || (t[2] = [
        e("path", { d: "M189.66,90.34a8,8,0,0,1,0,11.32L131.31,160l42.35,42.34A8,8,0,0,1,168,216H72a8,8,0,0,1-8-8V112a8,8,0,0,1,13.66-5.66L120,148.69l58.34-58.35A8,8,0,0,1,189.66,90.34ZM224,40H48a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : l(n) === "light" ? (a(), o("g", f, t[3] || (t[3] = [
        e("path", { d: "M230,48a6,6,0,0,1-6,6H48a6,6,0,0,1,0-12H224A6,6,0,0,1,230,48ZM179.76,91.76,78,193.52V112a6,6,0,0,0-12,0v96a6,6,0,0,0,6,6h96a6,6,0,0,0,0-12H86.48L188.24,100.24a6,6,0,0,0-8.48-8.48Z" }, null, -1)
      ]))) : l(n) === "regular" ? (a(), o("g", A, t[4] || (t[4] = [
        e("path", { d: "M232,48a8,8,0,0,1-8,8H48a8,8,0,0,1,0-16H224A8,8,0,0,1,232,48ZM178.34,90.34,80,188.69V112a8,8,0,0,0-16,0v96a8,8,0,0,0,8,8h96a8,8,0,0,0,0-16H91.31l98.35-98.34a8,8,0,0,0-11.32-11.32Z" }, null, -1)
      ]))) : l(n) === "thin" ? (a(), o("g", V, t[5] || (t[5] = [
        e("path", { d: "M228,48a4,4,0,0,1-4,4H48a4,4,0,0,1,0-8H224A4,4,0,0,1,228,48ZM181.17,93.17,76,198.34V112a4,4,0,0,0-8,0v96a4,4,0,0,0,4,4h96a4,4,0,0,0,0-8H81.66L186.83,98.83a4,4,0,1,0-5.66-5.66Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  v as default
};
